import { NavLink, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LayoutGrid, Table2, Calendar } from "lucide-react";

const VIEWS = [
  { to: "/board",    label: "Board",    icon: LayoutGrid, testId: "view-board" },
  { to: "/grid",     label: "Grid",     icon: Table2,     testId: "view-grid" },
  { to: "/timeline", label: "Timeline", icon: Calendar,   testId: "view-timeline" },
];

export default function ItemsLayout() {
  const loc = useLocation();
  const active = VIEWS.find((v) => v.to === loc.pathname) || VIEWS[0];
  return (
    <div className="animate-fade-in-up">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-2xl md:text-3xl font-medium text-surface-on tracking-tight">Workspace</h2>
          <p className="text-sm text-surface-onVariant mt-1">One collection of items, {active.label.toLowerCase()} view.</p>
        </div>
        <div className="inline-flex items-center gap-1 rounded-full bg-surface-container p-1" role="tablist" aria-label="View">
          {VIEWS.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              key={to} to={to}
              data-testid={testId}
              role="tab"
              className={({ isActive }) => cn(
                "inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ease-md",
                isActive ? "bg-primary text-primary-foreground" : "text-surface-on hover:bg-primary/8"
              )}
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
}
